import React, { useEffect, useRef } from 'react';
import './About.css';

const About = () => {
  const aboutRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('visible');
          }
        });
      },
      { threshold: 0.1 }
    );

    const elements = aboutRef.current.querySelectorAll('.fade-in, .slide-in-left, .slide-in-right');
    elements.forEach((el) => observer.observe(el));

    return () => observer.disconnect();
  }, []);

  const stats = [
    { number: '500+', label: 'Projetos Realizados' },
    { number: '10', label: 'Anos de Experiência em Projetos' }
  ];

  const services = [
    'Projetos de Construção Residencial',
    'Projetos Complementares',
    'Design de Interiores',
    'Aprovação de Projetos em Órgãos Competentes',
    'Projetos Arquitetônicos',
    'Reformas Corporativas e Residenciais'
  ];

  return (
    <section id="about" className="about section" ref={aboutRef}>
      <div className="container">
        <div className="about-content">
          <div className="about-text slide-in-left">
            <h2>Sobre o Escritório</h2>
            <p className="about-intro">
              Em nosso escritório, oferecemos soluções completas para transformar seu espaço em realidade. 
              Atuamos de forma integrada em todas as etapas, desde o projeto até a execução.
            </p>
            
            <div className="about-description">
              <p>
                Nosso compromisso é oferecer projetos completos, alinhando técnica, criatividade 
                e responsabilidade em cada detalhe.
              </p>
            </div>

            <div className="services-overview">
              <h4>Nossos Serviços</h4>
              <div className="services-list">
                {services.map((service, index) => (
                  <div key={index} className="service-item">
                    <span className="service-bullet">•</span>
                    <span className="service-name">{service}</span>
                  </div>
                ))}
              </div>
            </div>
          </div>

          {/* <div className="certifications">
            <h4>Formação e Certificações</h4>
            <ul>
              <li>Arquitetura e Urbanismo - UFRJ (2016)</li>
              <li>Especialização em Arquitetura Sustentável - USP (2018)</li>
              <li>Certificação LEED Green Associate (2020)</li>
              <li>CAU/RJ - Registro Ativo</li>
            </ul>
          </div> */}

          <div className="about-image slide-in-right">
            <div className="image-container">
              <div className="architect-photo">
                <img src="/bianca.jpg" alt="Escritório de Arquitetura" />
              </div>
              <div className="image-decoration"></div>
            </div>
          </div>
        </div>

        <div className="stats-section fade-in">
          <div className="stats-grid">
            {stats.map((stat, index) => (
              <div key={index} className="stat-item">
                <div className="stat-number">{stat.number}</div>
                <div className="stat-label">{stat.label}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
